import React from "react";

export default function About(props) {

// const [myStyle, setMyStyle] = useState({
//   color: "black",
//   backgroundColor: "white",
// });

// const [btntext, setBtnText] = useState(" Enable Dark Mode")

// const toggleStyle = () => {
//   if (myStyle.color === "black") {
//     setMyStyle({
//       color: "white",
//       backgroundColor: "black",
//       border: '1px solid white'
//     });
//     setBtnText(" Enable Light Mode")
//   } else {
//     setMyStyle({
//       color: "black",
//       backgroundColor: "white",
//     });
//     setBtnText(" Enable Dark Mode")
//   }
// };

let myStyle = {
  color: props.mode === 'dark' ? 'white' : 'black',
  backgroundColor: props.mode === 'dark' ? '#4e4b4b' : 'white'
}


  return ( 
    <div className="container rounded" style={myStyle}>
      <h1 className="my-3 mx-3">About Us</h1>
      <div className="accordion" id="accordionExample" style={{color: props.mode === 'dark' ? 'white' : '#242323'}}>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              style={myStyle}
            >
              <strong>Analyze Your Text</strong>
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body" style={myStyle}>
              <strong>Sun's TextUtils</strong> gives you a way to analyze your text quickly and efficiently. Be it word count, character count, pronounce, copy or reverse. This Web Speech API interface represents a speech request. (e.g. language, pitch and volume.)
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              style={myStyle}
            >
              <strong>Free To Use</strong>
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body" style={myStyle}>
              <strong>Sun's TextUtils</strong> is a free character counter tool that provides instant character count & word statistics for a given text. TextUtils reports the number of words and characters. Thus it is suitable for writing text with word/ chracter limit.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
              style={myStyle}
            >
              <strong>Browser Compatible</strong>
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse my-2"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body" style={myStyle}>
              This word counter software works in any web browsers such as Chrome, Firefox, Internet Explorer, Safari, Opera. It suits to count characters in facebook, blog, books, excel document, pdf document, essays etc. 
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container">
        <button
          className="btn btn-dark mx-1 my-1 rounded-pill bi bi-brightness-high mx-3 my-3"
          onClick={toggleStyle}
        > {btntext}
        </button>
      </div> */}
    </div>
  );
}


